export default "__VITE_ASSET__4ce140a0__"